import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { GenericApprovalService } from 'src/app/digigov/services/generic-approval.service';

@Component({
  selector: 'app-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.scss'],
})
export class AttachmentDialogComponent implements OnInit {
  multipleAllowed = true;
  isEdit = true;
  appAcceptedType = [
    'pdf',
    'png',
    'doc',
    'docx',
    'xlsx',
    'txt',
    'xls',
    'jpg',
    'jpeg',
  ];
  appMaxSize = 50000000;
  appMaxFiles = 10;
  isEditNoting;
  notingAttachmentId = null;
  finalPath = null;
  tempPath = null;
  previousPath = null;
  draftBase64: any;

  attachId: any;
  previewSrc: any;
  constructor(
    private dialogRef: MatDialogRef<AttachmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private generic: GenericApprovalService,
    private sanitize: DomSanitizer
  ) {}

  ngOnInit(): void {
    //this.isEditNoting = this.data?.isEditNoting;
    // this.notingAttachmentId = this.data?.notingAttachmentId;
    this.previousPath = this.data?.tempPath;
    this.generic.getPreviewData(this.previousPath).subscribe((res: any) => {
      this.draftBase64 = res.fileBytes;
      this.attachId = res?.attachId;
      this.previewSrc = this.sanitize.bypassSecurityTrustResourceUrl(
        'data:' + 'application/pdf' + ';base64,' + this.draftBase64
      );
      //  this.data.setValue(atob(this.draftBase64));
      //  this.draftTitle = res.data.docFileName;
      //  this.showAttachmentFlag = true;
    });
  }

  onFinalPath(path) {
    this.finalPath = path;
  }
  close() {
    this.dialogRef.close({
      //finalPath: this.finalPath,
    });
  }
}
